/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text is encoded as UTF-8 bytes, and each byte is shown as 8 bits. So ASCII letters are one group of 8 bits; emoji and accented characters use several.`)
};

const es_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El texto se codifica como bytes UTF-8, y cada byte se muestra como 8 bits. Las letras ASCII son un grupo de 8 bits; emoji y caracteres acentuados usan varios.`)
};

const de_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text wird als UTF-8-Bytes codiert, und jedes Byte wird als 8 Bit dargestellt. ASCII-Buchstaben sind also eine Gruppe von 8 Bit; Emojis und Buchstaben mit Akzenten benötigen mehrere.`)
};

const nl_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst wordt gecodeerd als UTF-8-bytes, en elke byte wordt weergegeven als 8 bits. ASCII-letters zijn dus één groep van 8 bits; emoji en geaccentueerde tekens gebruiken meerdere.`)
};

const fr_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le texte est codé en octets UTF-8, et chaque octet est affiché en 8 bits. Donc les lettres ASCII sont un groupe de 8 bits; les emoji et les caractères accentuées en utilisent plusieurs.`)
};

const it_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il testo viene codificato in byte UTF-8, e ogni byte viene mostrato come 8 bit. Quindi le lettere ASCII sono un gruppo di 8 bit; gli emoji e i caratteri accentati usano diversi.`)
};

const pt_br2_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto é codificado como bytes UTF-8, e cada byte é mostrado como 8 bits. Portanto, letras ASCII são um grupo de 8 bits; emoji e caracteres acentuados usam vários.`)
};

const pt_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto é codificado como bytes UTF-8, e cada byte é mostrado como 8 bits. Assim, as letras ASCII são um grupo de 8 bits; emoji e caracteres acentuados usam vários.`)
};

const ja_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストは UTF-8 バイトにエンコードされ、各バイトは 8 ビットとして表示されます。したがって、ASCII 文字は 1 つの 8 ビット グループです。絵文字とアクセント文字は複数を使用します。`)
};

const zh_tb_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本会被编码为UTF-8字节,每个字节以8位二进制表示。因此ASCII字母对应一组8位二进制;表情符号和带重音符号的字符则会用到多组。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_faq1_a", locale)
	if (locale === "en") return en_tb_faq1_a(inputs)
	if (locale === "es") return es_tb_faq1_a(inputs)
	if (locale === "de") return de_tb_faq1_a(inputs)
	if (locale === "nl") return nl_tb_faq1_a(inputs)
	if (locale === "fr") return fr_tb_faq1_a(inputs)
	if (locale === "it") return it_tb_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_tb_faq1_a(inputs)
	if (locale === "pt") return pt_tb_faq1_a(inputs)
	if (locale === "ja") return ja_tb_faq1_a(inputs)
	return zh_tb_faq1_a(inputs)
};